import { Subject } from 'rxjs';

const subject = new Subject();

export const notificationService = {
    emitReload: val => subject.next(val),
    reload: () => subject.asObservable()
};